<template>
	<div>
		<DialogBody class="gap-5" borderless>
			<ProfileWizardForm
				:profile="form"
				:form-errors="formErrors"
				:is-x-s="isXS"
				@change="handleProfile"
			/>
		</DialogBody>
		<DialogActions
			:accept-action="{ text: $t('web.profile.create.account.button') }"
			@accept="submit"
		/>
	</div>
</template>

<script setup lang="ts">
	import { ref } from 'vue'
	import { storeToRefs } from 'pinia'
	import { ProfileActions } from '~/actions/profile/action'
	import { Profile } from '~/models/Profile'
	import { useDeviceStore } from '~/store/device'

	const deviceStore = useDeviceStore()
	const { isXS } = storeToRefs(deviceStore)
	const profile = ref<Profile>()
	const formErrors = ref<Partial<Record<keyof Profile, string>>>({})

	profile.value = await ProfileActions.getProfile()

	const form = ref<Profile>({
		id: profile.value?.id,
		name: profile.value.name,
		birthYear: profile.value.birthYear,
		country: profile.value.country,
		countryName: profile.value.countryName,
		consentCommercialCommunications: profile.value.consentCommercialCommunications,
	} as Profile)

	const emit = defineEmits(['close'])

	const handleProfile = (profileForm: Profile): void => {
		cleanErrors(profileForm)
		form.value = { ...profileForm }
	}

	const sendData = async () => {
		await ProfileActions.updateProfile(form.value)
		emit('close')
	}

	const submit = async () => {
		const errors = await ProfileActions.validateProfile(form.value)

		if (!errors) return sendData()
		formErrors.value = errors
	}

	const cleanErrors = (profileForm: Profile) => {
		Object.keys(profileForm).forEach((key) => {
			const theKey = key as keyof Profile
			if (profileForm[theKey] !== form.value[theKey]) {
				formErrors.value[theKey] = ''
			}
		})
	}
</script>

<style scoped></style>
